import { Order } from './Order';
import { ReturnItem } from './ReturnItem';

export enum ReturnStatus {
  PENDING = "pending",
  APPROVED = "approved",
  REJECTED = "rejected",
  COMPLETED = "completed",
}

export const translateReturnStatus = (status: ReturnStatus): string => {
  switch (status) {
    case ReturnStatus.PENDING:
      return "Oczekujący";
    case ReturnStatus.APPROVED:
      return "Zatwierdzony";
    case ReturnStatus.REJECTED:
      return "Odrzucony";
    case ReturnStatus.COMPLETED:
      return "Zakończony";
  }
};

export interface Return {
  id: string;
  orderId: string;
  returnNumber: string;
  status: ReturnStatus;
  comments?: string;
  createdAt: Date;
  updatedAt: Date;
  
  // Relacje
  order?: Order;
  returnItems?: ReturnItem[];
}

export interface ReturnCreationAttributes {
  orderId: string;
  comments?: string;
}
